module.exports = __webpack_public_path__ + "img/icon-expense.1a371c4a.svg";